import { useState } from 'react';
import { useDispatch } from 'react-redux';

//
import Text from '../../../molecules/Text';

//
import { setHeader } from '../../../../../../../Redux/slices/certificate';

/**
 *
 */
function SubTitle({ headerState, preview }) {
  const { subTitle } = headerState;
  const { text, color, fontSize, alignment } = subTitle;
  const dispatch = useDispatch();

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleSave = (subTitleValue) => {
    dispatch(
      setHeader({
        ...headerState,
        subTitle: subTitleValue
      })
    );
  };

  return (
    <Text
      show={show}
      text={text}
      color={color}
      preview={preview}
      title={'Sub Title'}
      initialValue={subTitle}
      fontSize={fontSize}
      alignment={alignment}
      //
      handleSave={handleSave}
      handleShow={handleShow}
      handleClose={handleClose}
    />
  );
}

export default SubTitle;
